<!--
  @Description: 参天制药定制周报
  @Author: wang.y 
  @Date: 2022-10-11 
-->
<template>
  <div class="santen-container index">
    <div class="header">
      <div class="middle">
        <img :src="$store.state.static_img_url + 'pic/newsletter/vbdata-logo.png'" class="logo-img">
        <ul class="nav">
          <li :class="{active: slide_id == ''}">
            <a @click="haddleModelSlider('')">首页</a>
          </li>
          <li v-for="item,index in chapter_module" :key="index" :class="{active: slide_id == item.id}">
            <a @click="haddleModelSlider(item.id)">{{item.name}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="banner">
      <div class="banner-bg">
        <img :src="$store.state.static_img_url + 'pic/newsletter/vbdata-bg.png?v=31'">
      </div>
      <div class="banner-content">
        <div class="title">动脉橙-眼科月报打样</div>
        <Select v-model="chapter_params.chapter_id" class="chapter-sel" @on-change="haddleChangeChapter">
          <Option v-for="item in chapter_list" :value="item.id" :key="item.id">第{{item.num}}期 {{item.title}}</Option>
        </Select>
      </div>
    </div>
    <div class="content">
      <ul class="number-new">
          <li v-for="item,index in chapter_module" :key="index" class="number-item-light" :class="{'blue': item.id == '13'}" @click="haddleModelSlider(item.id)">
              <div class="number-l">
                  <p class="number_name">{{item.name}}</p>
                  <p class="number-line"></p>
              </div>
              <div class="number-r">
                  <span class="count" v-if="module_list[item.id]">{{module_list[item.id].count}}</span>
                  <i class="iconfont">&#xe647;</i>
              </div>
          </li>
      </ul>
      <div class="summary">
        <p class="tle">本期摘要</p>
        <div>
          <div v-html="chapter_detail.summary"></div>
        </div>
      </div>
      <div class="temps">
        <div class="temp" v-for="item,index in chapter_module" :key="index" :id="'tempLi' + item.id">
          <div class="temp-content">
            <div class="tle">
              <!-- <img :src="$store.state.static_img_url + 'pic/briefReport/icon_l.png'"> -->
              <img :src="$store.state.static_img_url + 'pic/briefReport/icon_l.png'">
              <span>{{item.name}}</span>
              <img :src="$store.state.static_img_url + 'pic/briefReport/icon_r.png'">
            </div>
            <div class="temp-tip" v-if="insight[item.id] && insight[item.id].length > 0">
              <i class="iconfont">&#xe654;</i>
              <div v-html="insight[item.id][0].text"></div>
            </div>
            <ul class="topic-list" v-if="module_list[item.id] && module_list[item.id]['topic'].length > 0">
              <li v-for="topicItem,topicIndex in module_list[item.id]['topic']" :key="topicIndex" v-show="topicIndex < 10 || show_all_list[item.id]">
                <div class="topic-r">
                  <p class="topic-tle" @click="goTopicDetail(topicItem)"><img :src="$store.state.static_img_url + 'pic/briefReport/slash.png'" class="slash"><span v-html="topicItem.title"></span></p>
                  <p class="topic-dec">{{topicItem.content}}</p>
                </div>
              </li>
            </ul>
            <ul class="project-list" v-if="module_list[item.id] && module_list[item.id]['entity'].length > 0">
              <li v-for="entityItem,entityIndex in entity_list(module_list[item.id]['entity'])" :key="entityIndex" v-show="entityIndex < 10 || show_all_list[item.id]">
                <div class="pro-top">
                  <div class="pro-img">
                    <a :href="entity_url(entityItem.type) + entityItem.uid" target="_blank">
                      <img :src="entityItem.logo_path | logo_show" />
                    </a>
                  </div>
                  <div class="pro-dec">
                    <p class="p1">
                      <a :href="entity_url(entityItem.type) + entityItem.uid" target="_blank">{{entityItem.short_name}}</a>
                    </p>
                    <p class="p2">
                      <span>最新轮次：{{entityItem.round_id | deal('round')}}</span>
                      <span v-if="entityItem.latest_event.event_time">融资时间：{{entityItem.latest_event.event_time | time_moment('YYYY-MM-DD')}}</span>
                    </p>
                  </div>
                </div>
                <div class="pro-btm">
                  <div class="pro-sm">
                    <div class="pro-l"><i class="iconfont">&#xe690;</i><template v-if="entityItem.type == 0">公司</template><template v-if="entityItem.type == 1">机构</template><template v-if="entityItem.type == 3">医院</template>简介</div>
                    <div class="pro-r">
                      <p>{{entityItem.summary | empty('暂无简介')}}</p>
                    </div>
                  </div>
                  <div class="pro-sm" v-for="entityItem2 in entityItem.temp" :key="entityItem2.id">
                    <div class="pro-l"><i class="iconfont">&#xe68e;</i>{{entityItem2.name}}</div>
                    <div class="pro-r">
                      <div class="tags">
                        <span class="tag" v-for="entityItem3,idx in entityItem2.arr" :key="idx">{{entityItem3.name}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <ul class="article-list" v-if="module_list[item.id] && module_list[item.id]['art'].length > 0">
              <li v-for="artItem,artIndex in module_list[item.id]['art']" :key="artIndex" v-show="artIndex < 10 || show_all_list[item.id]">
                <div class="article-img">
                  <a :href="$store.state.index2_path +'/'+ artItem.id" target="_blank">
                    <img :src="artItem.logo_path | logo_show" />
                  </a>
                </div>
                <div class="article-info">
                  <p class="p1"><a :href="$store.state.index2_path +'/'+ artItem.id" target="_blank" v-html="artItem.title"></a></p>
                  <p class="p2">{{artItem.summary}}</p>
                  <p class="p3">
                    <span><i class="iconfont">&#xe632;</i>{{artItem.publish_time | time_moment}}</span>
                    <span><i class="iconfont">&#xe645;</i>来源：动脉网</span>
                  </p>
                </div>
              </li>
            </ul>
            <ul class="article-list" v-if="module_list[item.id] && module_list[item.id]['report'].length > 0">
              <li v-for="reportItem,reportIndex in module_list[item.id]['report']" :key="reportIndex" v-show="reportIndex < 10 || show_all_list[item.id]">
                <div class="article-img">
                  <a :href="protocol + '//static-cdn.vcbeat.top/pdf/web/viewer-d8.html?file=' + $store.state.img_req_url + reportItem.file_path" target="_blank">
                    <img :src="reportItem.logo_path | logo_show" />
                  </a>
                </div>
                <div class="article-info">
                  <p class="p1"><a :href="protocol + '//static-cdn.vcbeat.top/pdf/web/viewer-d8.html?file=' + $store.state.img_req_url + reportItem.file_path" target="_blank" v-html="reportItem.title"></a></p>
                  <p class="p2">{{reportItem.summary}}</p>
                  <p class="p3">
                    <span v-if="reportItem.src_author"><i class="iconfont">&#xe645;</i>来源：{{reportItem.src_author}}</span>
                  </p>
                </div>
              </li>
            </ul>
            <div class="temp-bottom" v-if="module_list[item.id] && (module_list[item.id]['topic'].length > 10 || module_list[item.id]['entity'].length > 10 || module_list[item.id]['art'].length > 10 || module_list[item.id]['report'].length > 10)">
              <span class="more-btn" @click="showAllList(item.id)">
                <template v-if="!show_all_list[item.id]">查看全部</template>
                <template v-else>收起全部</template>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Spin fix v-if="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <BackTop></BackTop>
  </div>
</template>

<script>
import {
  addPuv,
  customReportDetail,
  chapterDetail,
  chapterModuleContent
} from '@/service'
import filter from 'js/filter'
export default {
  data() {
    return {
      loading: true,
      filter: filter,

      params: {
        uid: '307330e4c08c6869149fde728234af80',
      },

      chapter_params: {
        chapter_id: '',
        custom_report_id: '',
      },

      custom_report_detail: '',
      chapter_list: [],

      chapter_detail: '',
      chapter_module: [],

      module_list: {},
      insight: {},

      show_all_list: {},

      scroll_top: 0,
      temp_top_arr: [],
      slide_id: '',
    }
  },
  computed: {
    protocol() {
      return window.location.protocol
    },
    user_key() {
      return this.$store.state.user_key
    },
    dynview_tag() {
      return this.$store.state.dynview_tag
    },
    dynview_tag_type() {
      return this.$store.state.dynview_tag_type
    },
    entity_list() {
      return function (list) {
        let arr = []
        var dt = this.dynview_tag
        var dtt = this.dynview_tag_type
        for (var a = 0; a < list.length; a++) {
          var temp = []
          for (var b = 0; b < list[a].tag.length; b++) {
            var c = this.handleTag(dt, dtt, list[a].tag[b])
            var d = this.handleFindTag(c.type.id, temp)
            if (d) {
              d.arr.push(c.tag)
            } else {
              temp.push({
                id: c.type.id,
                name: c.type.name,
                arr: [c.tag],
              })
            }
          }
          arr.push({
            description: list[a].description,
            full_name: list[a].full_name,
            id: list[a].id,
            latest_event: list[a].latest_event,
            logo_path: list[a].logo_path,
            round_id: list[a].round_id,
            short_name: list[a].short_name,
            summary: list[a].summary,
            tag: list[a].tag,
            uid: list[a].uid,
            type: list[a].type,
            temp: temp,
          })
        }
        return arr
      }
    },
    entity_url() {
      return function (t) {
        if (t == 0) {
          return this.$store.state.index_path + '/companyDetail/'
        } else if (t == 1) {
          return this.$store.state.index_path + '/orgDetail/'
        } else if (t == 3) {
          return this.$store.state.index_path + '/hospitalDetail/'
        }
      }
    },
  },
  methods: {
    /**
     * 获取简报和期刊信息
     */
    async getCustomReportDetail() {
      let res = await customReportDetail(this.params, (error) => this.$Message.error('请求错误！'))
      if (res.status == 'success') {
        this.$set(this.$data, 'custom_report_detail', res.res[0])
        this.$set(this.$data, 'chapter_list', res.chapter)
        this.chapter_params.chapter_id = this.chapter_list[this.chapter_list.length - 1].id
        this.chapter_params.custom_report_id = this.custom_report_detail.id
        this.getChapterDetail()
        this.getAddPuv()
      } else {
        this.$Message.error(res.message)
      }
    },
    async getChapterDetail() {
      let res = await chapterDetail(this.chapter_params, (error) =>
        this.$Message.error('请求错误！')
      )
      if (res.status == 'success') {
        this.$set(this.$data, 'chapter_detail', res.res[0])
        this.$set(this.$data, 'chapter_module', res.module)
        res.module.map((a) => {
          this.getChapterModuleContent(a.id)
          this.show_all_list[a.id] = false
        })
      } else {
        this.$Message.error(res.message)
      }
    },
    async getChapterModuleContent(module_id) {
      let module_params = {
        chapter_id: this.chapter_params.chapter_id,
        module_id: module_id,
      }
      let res = await chapterModuleContent(module_params, (error) =>
        this.$Message.error('请求错误！')
      )
      if (res.status == 'success') {
        this.module_list[module_id] = res.content
        this.insight[module_id] = res.insight
        this.$forceUpdate()
        this.loading = false
      } else {
        this.$Message.error(res.message)
      }
    },
    handleTag(dt, dtt, id) {
      var own = this.handleFindTag(id, dt)
      var type
      if (own.pid == null && own.pgid == null) {
        type = this.handleFindTag(own.type_id, dtt)
      } else if (own.pid != null && own.pgid == null) {
        type = this.handleFindTag(this.handleFindTag(own.pid, dt).type_id, dtt)
      } else {
        type = this.handleFindTag(this.handleFindTag(own.pgid, dt).type_id, dtt)
      }
      return {
        type: type,
        tag: own,
      }
    },
    handleFindTag(id, arr) {
      for (var a = 0; a < arr.length; a++) {
        if (arr[a].id == id) {
          return arr[a]
          break
        }
      }
    },
    /**
     * 导航点击事件
     * item 点击的对象
     */
    haddleModelSlider(module_id) {
      let targetTop
      if (module_id !== '') {
        targetTop = $('#tempLi' + module_id).offset().top - 68 //滚动条目标位置
      } else {
        targetTop = 0
      }
      $('html, body').animate({ scrollTop: targetTop }, 200)
    },
    /**
     * 监听滚动条改变
     * 导航高亮
     */
    haddleScroll() {
      this.scroll_top = document.documentElement.scrollTop || document.body.scrollTop //滚动条的值
      this.temp_top_arr = []
      this.chapter_module.map((a) => {
        this.temp_top_arr.push({
          module_id: a.id,
          offset_top: $('#tempLi' + a.id).offset().top - 78,
        })
      })
      this.temp_top_arr.push({
        module_id: '',
        offset_top: 0,
      })
      this.temp_top_arr.sort((a, b) => a.offset_top - b.offset_top)
      for (let i = 0; i < this.temp_top_arr.length; i++) {
        if (this.scroll_top >= this.temp_top_arr[i].offset_top) {
          this.slide_id = this.temp_top_arr[i].module_id
        }
      }
      this.$forceUpdate()
    },
    showAllList(item_id) {
      this.show_all_list[item_id] = !this.show_all_list[item_id]
      this.$forceUpdate()
    },
    haddleChangeChapter(value) {
      this.chapter_params.chapter_id = value
      this.getChapterDetail()
    },
    async getAddPuv() {
      let puv_params = {
        user_key: this.user_key,
        url: window.location.href,
        row_id: this.custom_report_detail.id,
      }
      let res = await addPuv(puv_params, (error) => this.$Message.error('请求错误！'))
    },
    getDate(date) {
      if (date == null) {
        return date
      }
      return moment(date).format('YYYY/MM/DD')
    },
    goTopicDetail(item) {
      if(item.news_arr && item.news_arr.length) {
        window.open(item.news_arr[0].src_url, '_blank')
      } else {
        const href = this.$store.state.index2_path + '/newsDetail/' + item.uid
        window.open(href, '_blank')
      }
    }
  },
  created() {
    this.getCustomReportDetail()
  },
  mounted() {
    let _that = this
    window.onscroll = function () {
      _that.haddleScroll()
    }
  },
  beforeDestroy() {
    window.onscroll = ''
  }
}
</script>

<style lang="stylus" scoped>
@import './style/santen.stylus'
.santen-container
  .logo-img
    width: 103px
.index
  >>> .ivu-back-top-inner
    background-color: #fff
    i
      color: #999
    &:hover
      i
        color: #FA5A00
</style>